import React, {useEffect, useState} from 'react';
import { useAppSelector} from "../DAL/store";
import TagDetails from "../components/tag-details";
import Preset from "../../common/components/preset";
import Pagination from "../components/pagination";
import Preloader from "../../../../ui/svg/common/preloader";
import {ProfileDM} from "../../common/interfaces";
import {Popup} from "../../../../ui/popup/popup";

/**
 * the entry point - preset by tag
 */
const App: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [showLinkCopiedPopup, setShowLinkCopiedPopup] = useState(false);

    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const PresetsByTagData = useAppSelector((store) => store.PresetsByTagData);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    useEffect(() => {
        //on load: if there is no url param "page" set it
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.has("page") === false && PresetsByTagData.presetByPluginPage.pageNumber > 1){
            window.history.replaceState({}, '', document.location.pathname + "?page=" + PresetsByTagData.presetByPluginPage.pageNumber);
        }
    }, [PresetsByTagData.presetByPluginPage.pageNumber]);

    return (
        <div className="waves-box-lg mx-auto text-left px-5 md:px-12 mt-8 lg:mt-16">
            <TagDetails  />

            {!isLoading &&
                <div className="w-full mt-4">
                    <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-10">
                        {PresetsByTagData.presets.map((preset,index) => {
                            const presetTags = PresetsByTagData.presetTags.filter(tag => tag.presetID === preset.presetID);

                            const profileID = PresetsByTagData.presetProfilePairs.filter(pair => pair.presetID === preset.presetID)[0].profileID;
                            const profile = (PresetsByTagData.profiles as ProfileDM[]).filter(profile => profile.profileID === profileID)[0];
                            return <li className="grid-item pb-8" key={preset.presetID + "_" + index}>
                                        <Preset preset={preset} presetTags={presetTags}
                                                isHandleLinked={true} profile={profile}
                                                imgCdnDomain={imgCdnDomain} creatorsPath={creatorsPath}
                                                setShowLinkCopiedPopup={setShowLinkCopiedPopup}/>
                                    </li>
                        })}
                    </ul>
                </div>
            }
            {showLinkCopiedPopup && <Popup classes="py-10" close={() => setShowLinkCopiedPopup(false)}>
                <div className="ok-box" role="alert">The link was copied to clipboard</div>
            </Popup>}
            {isLoading && <div className="w-full flex items-center justify-center"><Preloader width="25px" height="25px" color="#4f4f4f" /></div>}

            {PresetsByTagData.presetByPluginPage.numberOfPages > 1 && <Pagination setIsLoading={setIsLoading} />}
        </div>

    );
};

export default App;

